import React, { useEffect } from "react";

// components
import Loader from "../../Container/Loader";
import Modal from "../../Container/Modal";
import RightSideBar from "../../Container/RightSidebar";

// style
import HomeStyle from "./style";

//  images
import Sort from "../../Assets/sort.svg";
import DeleteIcon from "../../Assets/Delete.svg";
import Pen from "../../Assets/pen.svg";
import { useState } from "react";

// -- redux
import { connect } from "react-redux";
import { GetBank, UpdateBankStatus, DeleteBank } from "../../Redux/Actions/BankAction";

function Banks(props) {
  const [response, setResponse] = useState(false);
  const [Open, SetOpen] = useState(false);
  const [Data, SetData] = useState("");
  const [sortType, setSortType] = useState("asc");
  const [sortBy, setSortBy] = useState("1");
  const [tableEntries, setTableEntries] = useState([]);
  const [OpenModal, setModal] = useState(false);
  const [Name, setName] = useState(false);
  const [BankId, setBankId] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem("selectedBank") !== "1") {
      sessionStorage.clear();
      window.location.replace("/admin");
    }
  }, []);

  useEffect(() => {
    if (props.search.length > 2) {
      const data = {
        sort_type: sortType,
        status: props.status.toString(),
        sort_by: sortBy,
        search_key: props.search,
      };
      props.GetBank(data);
    } else {
      const data = {
        sort_type: sortType,
        status: props.status.toString(),
        sort_by: sortBy,
        search_key: "",
      };
      props.GetBank(data);
    }
    SetOpen(false);
  }, [props.delete_data, props.edit_data, props.add_data, props.update_data, props.search, props.copy_data, sortBy, sortType, props.status]);

  useEffect(() => {
    if (props.data.data && props.data.data.data) {
      props.enabled(props.data.data.enabled);
      props.disabled(props.data.data.disabled);
      setTableEntries(props.data.data.data);
    }
    props.reload();
  }, [props.data, props.add_data, props.delete_data, props.edit_data, props.copy_data]);

  const handleSort = (e, type) => {
    e.preventDefault();
    if (type === "name") {
      setSortBy("2");
      sortType === "asc" ? setSortType("desc") : setSortType("asc");
    } else {
      setSortBy("1");
      sortType === "asc" ? setSortType("desc") : setSortType("asc");
    }
  };

  const CloseModal = (e, type) => {
    e.preventDefault();
    let data;
    if (type === "enable_yes") {
      data = {
        id: BankId,
        bank_status: 0,
      };
      props.UpdateBankStatus(data);
    } else {
      setModal(!OpenModal);
    }

    if (type === "disable_yes") {
      data = {
        id: BankId,
        bank_status: 1,
      };
      props.UpdateBankStatus(data);
    } else {
      setModal(!OpenModal);
    }

    if (type === "delete_yes") {
      props.DeleteBank(BankId);
      setModal(false);
    } else if (type === "delete_no") {
      setModal(false);
    }
  };

  const deleteBank = (e, type, id) => {
    console.log("Called");
    e.preventDefault();
    setModal(type);
    setBankId(id);
  };

  const handleEdit = (e, data) => {
    e.preventDefault();
    SetData(data);
    SetOpen(true);
  };

  useEffect(() => {
    setTimeout(function () {
      setResponse(true);
    }, 1000);
  }, []);

  const handleModal = (e, type, name, id) => {
    e.preventDefault();
    setModal(type);
    setName(name);
    setBankId(id);
  };

  useEffect(() => {
    setTableEntries([]);
  }, [props.delete_data, props.edit_data, props.add_data, props.update_data, props.copy_data, props.search, sortBy, sortType, props.status]);

  return (
    <>
      {props.loading && <Loader />}
      <div className="ml-4 mr-4">
        <div className="module-table-wrap table-responsive">
          <div className="table-wrap">
            <table className="table table-bordered m-0">
              <thead className="text-grey-6">
                <tr>
                  <th scope="col" className="dark-background cursor-pointer" onClick={(e) => handleSort(e, "code")}>
                    <div className="d-flex justify-content-between">
                      <span className="f-16">Code</span>
                      <img src={Sort} alt="sort" className="ml-2" />
                    </div>
                  </th>
                  <th scope="col" className="dark-background cursor-pointer" onClick={(e) => handleSort(e, "name")}>
                    <div className="d-flex justify-content-between">
                      <span className="f-16">Name</span>
                      <img src={Sort} alt="sort" className="ml-2" />
                    </div>
                  </th>
                  <th scope="col" className="dark-background">
                    <div className="d-flex justify-content-between">
                      <span className="f-16">Address</span>
                    </div>
                  </th>
                  <th scope="col" className="dark-background">
                    <span className="f-16">Status</span>
                  </th>
                  <th scope="col" className="dark-background">
                    <span className="f-16">Action</span>
                  </th>
                </tr>
              </thead>
              <tbody className="light-grey-background text-white">
                {tableEntries.length > 0
                  ? tableEntries.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td>
                            <span className="f-16">{item.bank_code}</span>
                          </td>
                          <td>
                            <span className="f-16">{item.name}</span>
                          </td>
                          <td>
                            <span className="f-16">{item.street}</span>
                          </td>
                          <td className="text-center">
                            <label className="switch mb-0">
                              <input type="checkbox" checked={item.bank_status === 1} readOnly onClick={(e) => handleModal(e, item.bank_status === 1 ? "enable" : "disable", item.name, item.id)} />
                              <span className="slider round" />
                            </label>
                          </td>
                          <td>
                            <div className="d-flex">
                              <img
                                src={Pen}
                                onClick={(e) => {
                                  handleEdit(e, item);
                                }}
                                alt="pen"
                                className="ml-2 mr-2 cursor-pointer"
                              />
                              <img onClick={(e) => deleteBank(e, "delete", item.id)} src={DeleteIcon} alt="Delete" className="ml-2 mr-3 cursor-pointer" />
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  : props.table_loading === false && (
                      <tr>
                        <td colSpan="9" className="text-center border-0">
                          <p className="m-0 text-white">Nothing found</p>
                        </td>
                      </tr>
                    )}
              </tbody>
            </table>

            <HomeStyle />
          </div>
        </div>

        <RightSideBar Type="Edit" data={Data} sidebar={Open} close={() => SetOpen(false)} response={(e) => e} />

        {OpenModal && <Modal Name={Name} Type={OpenModal} Close={(e, type) => CloseModal(e, type)} />}
      </div>
    </>
  );
}

const mapStateToProps = ({ GetBankReducer }) => {
  const { loading, table_loading, data, update_data, delete_data, edit_data, add_data, copy_data } = GetBankReducer;
  return {
    loading,
    table_loading,
    data,
    update_data,
    delete_data,
    edit_data,
    add_data,
    copy_data,
  };
};

const mapDispatchToProps = {
  GetBank,
  UpdateBankStatus,
  DeleteBank,
};

export default connect(mapStateToProps, mapDispatchToProps)(Banks);
